import React, { useState, useRef, useContext, useEffect } from "react";
import SignatureCanvas from "react-signature-canvas";
import { db } from '../Firebase Functions/firebase';
import { addDoc, collection, doc, setDoc, getDoc } from "firebase/firestore";
import { getStorage, ref, uploadBytes, getDownloadURL, getBytes } from "firebase/storage";
import { useNavigate, useParams } from 'react-router-dom';
import { AuthContext } from "../hooks/AuthProvider";
import IncidentEmailSender from "../Email Functions/IncidentEmailSender";
import IncidentReportPDF from "../PDF Functions/IncidentReportPDF";
import { pdf } from '@react-pdf/renderer';
import "../TruckServices/ChecklistForm.css";
import { UpdateQuickBaseIncidentReport, isIncidentReportCompleted } from "../Quickbase Functions/IncidentReportQBUpdate";


function IncidentReportForm() {
  const { draftId } = useParams();
  const { currentUser } = useContext(AuthContext);
  const [showValidationModal, setShowValidationModal] = useState(false);
  const navigate = useNavigate();
  const [formData, setFormData] = useState(initialFormData());
  const [generatedPdfBlob, setGeneratedPdfBlob] = useState(null);
  const [generatedPdfBase64, setGeneratedPdfBase64] = useState(null);
  const [imageFiles, setImageFiles] = useState([]);
  const [status, setStatus] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [EmailModalOpen, setEmailModalOpen] = useState(false);
  const [selectedReport, setSelectedReport] = useState(null);
  const [lastAutoSaveTime, setLastAutoSaveTime] = useState(null);
  const [isAutoSaving, setIsAutoSaving] = useState(false);
  const [recipientEmail, setRecipientEmail] = useState('');
  const [requiredSignatureType, setRequiredSignatureType] = useState('');
  const [showSendLinkModal, setShowSendLinkModal] = useState(false);
  const supervisorSigRef = useRef(null);
  const driverSigRef = useRef(null);
  const passengerSigRef = useRef(null);
  const [showDraftSentModal, setShowDraftSentModal] = useState(false);
  const [isCompletedInQuickbase, setIsCompletedInQuickbase] = useState(false);
  const [hasSubmitted, setHasSubmitted] = useState(false);
  const [hasLoadedSupervisorSignature, setHasLoadedSupervisorSignature] = useState(false);
  const [hasLoadedDriverSignature, setHasLoadedDriverSignature] = useState(false);
  const [hasLoadedPassengerSignature, setHasLoadedPassengerSignature] = useState(false);

  const [signatureLoading, setSignatureLoading] = useState({
    supervisor: false,
    driver: false,
    passenger: false,
  });
  
  
  
  
  

  // Initial form data structure
  function initialFormData() {
    return {
      employee: { name: "", address: "", phone: "", market: "", jobTitle: "" },
      occurrence: { startTime: "", accidentTime: "", weather: "", injuryDate: "", notificationDate: "", location: "" },
      injury: { type: "", bodyPart: "", equipmentUsed: "", activity: "", assignedJob: false, receivedTraining: false, worePPE: false },
      witnesses: [],
      treatment: { initialTreatment: false, facility: "", accompanied: false, byWhom: "" },
      vehicle: { truckNumber: "", damageDescription: "", claimant: { name: "", phone: "" } },
      correctiveAction: { explanation: "", employeeNegligence: false, deduction: false },
      supervisor: { name: "", phone: "", signature: "" },
      driver: { name: "", phone: "", signature: "" },
      passenger: { name: "", phone: "", signature: "" },
    };
  }

  const marketOptions = [
  'SS1', 'SS2', 'SS3', 'SS4', 'NS1', 'NS2', 'COA1', 'FOL', 'NS3', 'COA2',
  'SS5', 'LAF', 'LKC', 'BR1', 'BR2', 'BR3', 'BR4', 'BR5', 'BR6', 'BR7',
  'NLA1', 'NLA2', 'GP1', 'GP2', 'GP3', 'GP4', 'GP5', 'BAY1', 'BAY2', 'BAY3',
  'BAY4', 'BAY5', 'ALX', 'BIR', 'NAS', 'TUS', 'LAB', 'HOU1', 'HOU2', 'HOU3',
  'ORL', 'JAX', 'MEM1', 'MEM2', 'MEM3', 'JXV', 'SOC', 'NIL'
];

  useEffect(() => {
  const checkQuickbaseLock = async () => {
    if (!draftId) return;
    const completed = await isIncidentReportCompleted(draftId);
    setIsCompletedInQuickbase(completed);
  };
  checkQuickbaseLock();
}, [draftId]);

  


  useEffect(() => {
    const canvases = document.querySelectorAll('.signature-canvas');
    const preventScroll = (e) => e.preventDefault();
  
    canvases.forEach(canvas => {
      canvas.style.touchAction = 'none';
      canvas.addEventListener('touchmove', preventScroll, { passive: false });
    });
  
    return () => {
      canvases.forEach(canvas => {
        canvas.removeEventListener('touchmove', preventScroll);
      });
    };
  }, []);
  
  
  
  

  useEffect(() => {
    const loadSignature = (ref, signatureDataURL, setHasLoaded, type) => {
      if (!signatureDataURL || !ref.current) {
        return;
      }
    
      const currentDataUrl = ref.current.isEmpty() ? null : ref.current.toDataURL();
      if (currentDataUrl === signatureDataURL) {
        return;
      }
    
      setSignatureLoading(prev => ({ ...prev, [type]: true }));
    
      ref.current.clear();
      ref.current.fromDataURL(signatureDataURL);
      setHasLoaded(true);
    
      setTimeout(() => {
        setSignatureLoading(prev => ({ ...prev, [type]: false }));
      }, 50);
    };
    
  
    loadSignature(supervisorSigRef, formData.supervisor?.signature, setHasLoadedSupervisorSignature, 'supervisor');
    loadSignature(driverSigRef, formData.driver?.signature, setHasLoadedDriverSignature, 'driver');
    loadSignature(passengerSigRef, formData.passenger?.signature, setHasLoadedPassengerSignature, 'passenger');
  }, [
    formData.supervisor?.signature,
    formData.driver?.signature,
    formData.passenger?.signature,
  ]);
  
  
  
  
  
  

  useEffect(() => {
    if (!draftId) return;

    const loadDraft = async () => {
      try {
        const docRef = doc(db, "incidentReports", draftId);
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
          const data = docSnap.data();
          setFormData(data);
          setSelectedReport(data);
          setStatus('Draft loaded. You can continue filling the form.');

        } else {
          alert('Draft not found.');
        }
      } catch (error) {
        console.error('Error loading draft:', error);
        alert('Failed to load draft. Please try again.');
      }
    };

    loadDraft();
  }, [draftId]);

  useEffect(() => {
    if (showValidationModal || EmailModalOpen) {
      document.body.classList.add('modal-open');
    } else {
      document.body.classList.remove('modal-open');
    }
  }, [showValidationModal, EmailModalOpen]);
  

  useEffect(() => {
    const interval = setInterval(autoSaveDraft, 60000);
    return () => clearInterval(interval);
  }, [formData, draftId, currentUser]);


  const Spinner = () => (
    <div style={{
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      zIndex: 2,
    }}>
      <div className="loader"></div>
    </div>
  );

  function debounce(func, wait) {
    let timeout;
    return function(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }
  
  


  const updateFormData = (section, field, value) => {
    setFormData(prev => ({
      ...prev,
      [section]: { ...prev[section], [field]: value },
    }));
  };

  const handleChange = (section, field, value) => {
    setFormData(prev => ({
      ...prev,
      [section]: {
        ...prev[section],
        [field]: value
      }
    }));
  };

  const getDashboardLink = () => {
    if (!currentUser || !currentUser.type) return '/';
    switch (currentUser.type.toLowerCase()) {
      case 'admin':
        return '/admin-dash';
      case 'manager':
        return '/manager-dashboard';
      case 'supervisor':
        return '/supervisor-dashboard';
      case 'spray_tech':
        return '/spray-tech-dashboard';
      default:
        return '/';
    }
  };
  

  

  const autoSaveDraft = async () => {
    if (!currentUser) return;
    setIsAutoSaving(true);

    try {
      const draftRef = draftId ? doc(db, "incidentReports", draftId) : doc(collection(db, "incidentReports"));
      const latestData = buildDraftData();
         await setDoc(draftRef, latestData);
         setFormData(latestData); // ✅ this updates your local state!

      if (!draftId) navigate(`/incident-report/resume/${draftRef.id}`);
      setLastAutoSaveTime(new Date().toLocaleTimeString());
    } catch (error) {
      console.error('Auto-save failed:', error);
    } finally {
      setIsAutoSaving(false);
    }
  };

  const getSignature = (ref, existingSignature) => {
    if (ref?.current && !ref.current.isEmpty()) {
      return ref.current.getTrimmedCanvas().toDataURL("image/png");
    }
    return existingSignature || "";
  };
  
  

  const buildDraftData = () => ({
    ...formData,
    supervisor: {
      ...formData.supervisor,
      signature: getSignature(supervisorSigRef, formData.supervisor.signature),
    },
    driver: {
      ...formData.driver,
      signature: getSignature(driverSigRef, formData.driver.signature),
    },
    passenger: {
      ...formData.passenger,
      signature: formData.passengerInvolved
        ? getSignature(passengerSigRef, formData.passenger.signature)
        : "",
    },
    timestamp: new Date().toISOString(),
    createdBy: currentUser?.email || "anonymous",
    status: 'draft',
  });
  
  
  

  const saveDraft = async () => {
    if (!currentUser) return;
    setIsSubmitting(true);
  
    try {
      const uploadedImageURLs = [];
  
      const storage = getStorage();
      for (const file of imageFiles) {
        const storageRef = ref(storage, `incidentReports/${Date.now()}-${file.name}`);
        await uploadBytes(storageRef, file);
        const downloadURL = await getDownloadURL(storageRef);
        uploadedImageURLs.push(downloadURL);
      }

      const allImageURLs = [
        ...(formData.attachments?.imageURLs || []),
        ...uploadedImageURLs,
      ];
      
  
      const draftRef = draftId
        ? doc(db, "incidentReports", draftId)
        : doc(collection(db, "incidentReports"));
  
      const draftData = {
        ...buildDraftData(),
        attachments: {
          ...formData.attachments,
          imageURLs: allImageURLs,
        },
      };
  
      await setDoc(draftRef, draftData);
  
      if (!draftId) navigate(`/incident-report/resume/${draftRef.id}`);
  
      const draftLink = `${window.location.origin}/incident-report/resume/${draftRef.id}`;
      setShowValidationModal(false);
      setShowDraftSentModal(true);
  
      navigator.clipboard.writeText(draftLink).catch(() => {
        console.warn("Clipboard write was blocked by the browser.");
      });
      setTimeout(() => navigate(getDashboardLink()), 1500);
    } catch (error) {
      console.error("Error saving draft:", error);
      alert("Failed to save draft. Please try again.");
    } finally {
      setIsSubmitting(false);
    }

  };

 const handleNestedChange = (section, subSection, field, value) => {
      setFormData(prev => ({
        ...prev,
        [section]: {
          ...prev[section],
          [subSection]: {
            ...prev[section][subSection],
            [field]: value
          }
        }
      }));
    };
  
    const handleImageUpload = (e) => {
      const files = Array.from(e.target.files);
      if (files.length + imageFiles.length > 10) {
        alert("You can only upload up to 10 images.");
        return;
      }
      setImageFiles(prev => [...prev, ...files]);
    };
  
    const handleRemoveImage = (indexToRemove) => {
      setImageFiles((prev) => prev.filter((_, index) => index !== indexToRemove));
    };
  

    
    
    
    
    
    
    

  

  const validateForm = () => {
  const requiredQuickBaseFields = [
    formData.employee.name,
    formData.employee.division,
    formData.occurrence.injuryDate
  ];

  const requiredTextFields = [
    ...requiredQuickBaseFields,
    formData.employee.address,
    formData.employee.phone,
    formData.employee.market,
    formData.employee.jobTitle,
    formData.occurrence.startTime,
    formData.occurrence.accidentTime,
    formData.occurrence.weather,
    formData.occurrence.notificationDate,
    formData.occurrence.location,
    formData.injury.type,
    formData.injury.bodyPart,
    formData.injury.equipmentUsed,
    formData.injury.activity,
    formData.supervisor.name,
    formData.supervisor.phone,
    formData.supervisor.report,
  ];

  const truckInvolved = formData.vehicle.truckNumber?.trim() !== "";
  if (truckInvolved) {
    requiredTextFields.push(
      formData.driver.name,
      formData.driver.phone
    );
  }

  if (formData.passengerInvolved) {
    requiredTextFields.push(
      formData.passenger.name,
      formData.passenger.phone
    );
  }

  if (formData.witnesses.length > 0) {
    formData.witnesses.forEach(witness => requiredTextFields.push(witness));
  }

  const allTextFieldsFilled = requiredTextFields.every(field => field?.trim() !== '');

  const supervisorSignature = supervisorSigRef.current && !supervisorSigRef.current.isEmpty();
  const driverSignature = truckInvolved
    ? driverSigRef.current && !driverSigRef.current.isEmpty()
    : true;
  const passengerSignature = formData.passengerInvolved
    ? passengerSigRef.current && !passengerSigRef.current.isEmpty()
    : true;

  const allCheckboxesAnswered = (
    typeof formData.injury.assignedJob === 'boolean' &&
    typeof formData.injury.receivedTraining === 'boolean' &&
    typeof formData.injury.worePPE === 'boolean' &&
    typeof formData.correctiveAction.employeeNegligence === 'boolean' &&
    typeof formData.correctiveAction.deduction === 'boolean' &&
    typeof formData.treatment.accompanied === 'boolean' &&
    typeof formData.treatment.initialTreatment === 'boolean'
  );

  return allTextFieldsFilled && supervisorSignature && driverSignature && passengerSignature && allCheckboxesAnswered;
};

  
  
  const convertImagesToBase64 = async (imageUrls) => {
  const base64Images = [];
  const storage = getStorage();

  for (const url of imageUrls.filter(Boolean)) {
    try {
      const match = url.match(/o\/(.+?)\?/);
      if (!match) continue;

      const path = decodeURIComponent(match[1]);
      const fileRef = ref(storage, path);
      const bytes = await getBytes(fileRef);

      const blob = new Blob([bytes], { type: 'image/jpeg' });

      const base64 = await new Promise((resolve) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.readAsDataURL(blob);
      });

      base64Images.push(base64);
    } catch (error) {
      console.error('Error converting image to base64:', error);
    }
  }

  return base64Images;
};

  
  const handleSubmit = async (e) => {
  e.preventDefault();

  if (!validateForm()) {
    setShowValidationModal(true);
    return;
  }

  if (isCompletedInQuickbase) {
  alert("This incident report is locked and cannot be resubmitted.");
  return;
}


  setHasSubmitted(true);
  setIsSubmitting(true);
  setStatus('Uploading images...');

  try {
    const uploadedImageURLs = [];
    const storage = getStorage();

    for (const file of imageFiles) {
      const storageRef = ref(storage, `incidentReports/${Date.now()}-${file.name}`);
      await uploadBytes(storageRef, file);
      const downloadURL = await getDownloadURL(storageRef);
      uploadedImageURLs.push(downloadURL);
    }

    const allImageURLs = [
      ...(formData.attachments?.imageURLs || []),
      ...uploadedImageURLs,
    ];

    const draftRef = draftId
      ? doc(db, "incidentReports", draftId)
      : doc(collection(db, "incidentReports"));

    const draftData = {
      ...buildDraftData(),
      attachments: {
        ...formData.attachments,
        imageURLs: allImageURLs,
      },
    };

    await setDoc(draftRef, draftData);
    const incidentId = draftRef.id;

    const reportData = {
      ...draftData,
      supervisor: {
        ...draftData.supervisor,
        signature: supervisorSigRef.current?.getTrimmedCanvas().toDataURL("image/png") || null,
      },
      driver: {
        ...draftData.driver,
        signature: driverSigRef.current?.getTrimmedCanvas().toDataURL("image/png") || null,
      },
      passenger: {
        ...draftData.passenger,
        signature: passengerSigRef.current?.getTrimmedCanvas().toDataURL("image/png") || null,
      },
      status: 'submitted',
    };

    await setDoc(draftRef, reportData, { merge: true });

    setStatus('Converting images for PDF...');

    const base64Images = await convertImagesToBase64(allImageURLs);

    setStatus('Generating PDF for QuickBase...');

    const pdfBlob = await pdf(
      <IncidentReportPDF reportData={{ ...reportData, id: incidentId }} base64Images={base64Images} />
    ).toBlob();

    const arrayBuffer = await pdfBlob.arrayBuffer();
    const pdfBase64 = btoa(
      new Uint8Array(arrayBuffer).reduce((data, byte) => data + String.fromCharCode(byte), '')
    );

    setGeneratedPdfBlob(pdfBlob);
    setGeneratedPdfBase64(pdfBase64);


    console.log("📄 PDF Base64 length:", pdfBase64.length);
    await UpdateQuickBaseIncidentReport(incidentId, pdfBase64);
    console.log("✅ QuickBase update successful.");

    setFormData(reportData);
    setSelectedReport({ ...reportData, id: incidentId });
    setEmailModalOpen(true);

    setStatus('Incident report submitted. Sending email...');
  } catch (error) {
    console.error('[IncidentReportForm] Error during submission:', error);
    setStatus('Failed to submit report. Please try again.');
    alert("Failed to submit incident report.");
  } finally {
    setIsSubmitting(false);
    setTimeout(() => navigate(getDashboardLink()), 1500);
  }
};

  
  
  

  return (
    <form onSubmit={handleSubmit} className="checklist-form" noValidate>
      <h1 className="form-title">Incident Investigation Report</h1>

     {/* Employee Information */}
<h2 className="section-title">Employee Information</h2>

<div className="form-group">
  <label>Full Name (Last, First, MI)</label>
  <input
    type="text"
    value={formData.employee.name}
    onChange={(e) => handleChange("employee", "name", e.target.value)}
    className="form-control"
    disabled={isCompletedInQuickbase}
  />
</div>

<div className="form-group">
  <label>Address (Including Zip)</label>
  <input
    type="text"
    value={formData.employee.address}
    onChange={(e) => handleChange("employee", "address", e.target.value)}
    className="form-control"
    disabled={isCompletedInQuickbase}
  />
</div>

<div className="form-group">
  <label>Phone Number</label>
  <input
    type="tel"
    value={formData.employee.phone}
    onChange={(e) => handleChange("employee", "phone", e.target.value)}
    className="form-control"
    disabled={isCompletedInQuickbase}
  />
</div>

<div className="form-group">
  <label htmlFor="market" className="form-label">Market Area</label>
  <select
    id="market"
    name="market"
    className="form-input"
    disabled={isCompletedInQuickbase}
    value={formData.employee.market}
    onChange={(e) =>
      setFormData({
        ...formData,
        employee: {
          ...formData.employee,
          market: e.target.value,
        },
      })
    }
    required
  >
    <option value="">Select a Market</option>
    {marketOptions.map((option) => (
      <option key={option} value={option}>
        {option}
        
      </option>
    ))}
    
  </select>
</div>



<div className="form-group">
  <label>Employee Title</label>
  <input
    type="text"
    value={formData.employee.jobTitle}
    onChange={(e) => handleChange("employee", "jobTitle", e.target.value)}
    className="form-control"
    disabled={isCompletedInQuickbase}
  />
</div>

<div className="form-group">
  <label>Involved Truck Number</label>
  <input
    type="text"
    value={formData.vehicle.truckNumber}
    onChange={(e) => handleChange("vehicle", "truckNumber", e.target.value)}
    className="form-control"
    disabled={isCompletedInQuickbase}
  />
</div>





{/* Occurrence Section */}
<h2 className="section-title">Occurrence Details</h2>

<div className="form-group">
  <label>Time Employee Began Work</label>
  <input
    type="time"
    value={formData.occurrence.startTime}
    onChange={(e) => handleChange("occurrence", "startTime", e.target.value)}
    className="form-control"
  />
</div>

<div className="form-group">
  <label>Time of Accident</label>
  <input
    type="time"
    value={formData.occurrence.accidentTime}
    onChange={(e) => handleChange("occurrence", "accidentTime", e.target.value)}
    className="form-control"
    disabled={isCompletedInQuickbase}
  />
</div>

<div className="form-group">
  <label>Weather</label>
  <input
    type="text"
    value={formData.occurrence.weather}
    onChange={(e) => handleChange("occurrence", "weather", e.target.value)}
    className="form-control"
    disabled={isCompletedInQuickbase}
  />
</div>

<div className="form-group">
  <label>Date of Injury</label>
  <input
    type="date"
    value={formData.occurrence.injuryDate}
    onChange={(e) => handleChange("occurrence", "injuryDate", e.target.value)}
    className="form-control"
    disabled={isCompletedInQuickbase}
  />
</div>

<div className="form-group">
  <label>Date Notified</label>
  <input
    type="date"
    value={formData.occurrence.notificationDate}
    onChange={(e) => handleChange("occurrence", "notificationDate", e.target.value)}
    className="form-control"
  />
</div>

<div className="form-group">
  <label>Location of Incident</label>
  <input
    type="text"
    value={formData.occurrence.location}
    onChange={(e) => handleChange("occurrence", "location", e.target.value)}
    className="form-control"
    disabled={isCompletedInQuickbase}
  />
</div>

{/* Injury Info */}
<h2 className="section-title">Injury / Illness Details</h2>

<div className="form-group">
  <label>Type of Injury or Illness</label>
  <input
    type="text"
    value={formData.injury.type}
    onChange={(e) => handleChange("injury", "type", e.target.value)}
    className="form-control"
  />
</div>

<div className="form-group">
  <label>Body Part Affected</label>
  <input
    type="text"
    value={formData.injury.bodyPart}
    onChange={(e) => handleChange("injury", "bodyPart", e.target.value)}
    className="form-control"
    disabled={isCompletedInQuickbase}
  />
</div>

<div className="form-group">
  <label>Equipment / Materials Used</label>
  <input
    type="text"
    value={formData.injury.equipmentUsed}
    onChange={(e) => handleChange("injury", "equipmentUsed", e.target.value)}
    className="form-control"
  />
</div>

<div className="form-group">
  <label>Specific Activity at Time of Injury</label>
  <input
    type="text"
    value={formData.injury.activity}
    onChange={(e) => handleChange("injury", "activity", e.target.value)}
    className="form-control"
    disabled={isCompletedInQuickbase}
  />
</div>

<div className="form-group">
  <label>Was this caused by employee negligence?</label>
  <div className="toggle-buttons">
    <label>
      <input
        type="checkbox"
        checked={formData.correctiveAction.employeeNegligence === true}
        onChange={() =>
          setFormData((prev) => ({
            ...prev,
            correctiveAction: {
              ...prev.correctiveAction,
              employeeNegligence: true
            }
          }))
        
        }
        disabled={isCompletedInQuickbase}
      />
      Yes
    </label>
    <label style={{ marginLeft: "20px" }}>
      <input
        type="checkbox"
        checked={formData.correctiveAction.employeeNegligence === false}
        onChange={() =>
          setFormData((prev) => ({
            ...prev,
            correctiveAction: {
              ...prev.correctiveAction,
              employeeNegligence: false
            }
          }))
        }
        disabled={isCompletedInQuickbase}
      />
      No
    </label>
  </div>
</div>

{/* Will there be an employee deduction? */}
<div className="form-group">
  <label>Will there be an employee deduction?</label>
  <div className="toggle-buttons">
    <label>
      <input
        type="checkbox"
        checked={formData.correctiveAction.deduction === true}
        onChange={() =>
          setFormData((prev) => ({
            ...prev,
            correctiveAction: {
              ...prev.correctiveAction,
              deduction: true
            }
          }))
        }
        disabled={isCompletedInQuickbase}
      />
      Yes
    </label>
    <label style={{ marginLeft: "20px" }}>
      <input
        type="checkbox"
        checked={formData.correctiveAction.deduction === false}
        onChange={() =>
          setFormData((prev) => ({
            ...prev,
            correctiveAction: {
              ...prev.correctiveAction,
              deduction: false
            }
          }))
        }
        disabled={isCompletedInQuickbase}
      />
      No
    </label>
  </div>
</div>

{/* If no deduction, explain why */}
{formData.correctiveAction.deduction === false && (
  <div className="form-group">
    <label>If no employee deduction, please explain why:</label>
    <textarea
      value={formData.correctiveAction.explanation}
      onChange={(e) =>
        setFormData((prev) => ({
          ...prev,
          correctiveAction: {
            ...prev.correctiveAction,
            explanation: e.target.value
          }
        }))
      }
      className="form-control"
      disabled={isCompletedInQuickbase}
    />
  </div>
)}

{/* Were there any witnesses? */}
<div className="form-group">
  <label>Were there any witnesses?</label>
  <div className="toggle-buttons">
    <label>
      <input
        type="checkbox"
        checked={formData.witnesses.length > 0}
        onChange={(e) =>
          setFormData((prev) => ({
            ...prev,
            witnesses: e.target.checked ? [""] : []
          }))
        }
        disabled={isCompletedInQuickbase}
      />
      Yes
    </label>
    <label style={{ marginLeft: "20px" }}>
      <input
        type="checkbox"
        checked={formData.witnesses.length === 0}
        onChange={(e) =>
          setFormData((prev) => ({
            ...prev,
            witnesses: []
          }))
        }
        disabled={isCompletedInQuickbase}
      />
      No
    </label>
  </div>
</div>

{/* Witness names (if any) */}
{formData.witnesses.length > 0 && (
  <div className="form-group">
    <label>List Witness Names</label>
    {formData.witnesses.map((witness, index) => (
      <input
        key={index}
        type="text"
        value={witness}
        onChange={(e) => {
          const updated = [...formData.witnesses];
          updated[index] = e.target.value;
          setFormData((prev) => ({ ...prev, witnesses: updated }));
        }}
        className="form-control"
        disabled={isCompletedInQuickbase}
        placeholder={`Witness ${index + 1}`}
      />
    ))}
    <button
      type="button"
      onClick={() =>
        setFormData((prev) => ({
          ...prev,
          witnesses: [...prev.witnesses, ""]
        }))
      }
      className="add-button"
      disabled={isCompletedInQuickbase}
    >
      + Add Witness
    </button>
  </div>
)}

{/* Was there a passenger? */}
<div className="form-group">
  <label>Was there a passenger involved?</label>
  <div className="toggle-buttons">
    <label>
      <input
        type="checkbox"
        checked={formData.passengerInvolved === true}
        onChange={() =>
          setFormData((prev) => ({ ...prev, passengerInvolved: true }))
        }
        disabled={isCompletedInQuickbase}
      />
      Yes
    </label>
    <label style={{ marginLeft: "20px" }}>
      <input
        type="checkbox"
        checked={formData.passengerInvolved === false}
        onChange={() =>
          setFormData((prev) => ({ ...prev, passengerInvolved: false }))
        }
        disabled={isCompletedInQuickbase}
      />
      No
    </label>
  </div>
</div>
{formData.passengerInvolved && (
  <div className="form-group">
    <h3>Passenger</h3>

    <label>Name</label>
    <input
      type="text"
      value={formData.passenger.name}
      onChange={(e) => handleChange("passenger", "name", e.target.value)}
      className="form-control"
      disabled={isCompletedInQuickbase}
    />

    <label>Phone</label>
    <input
      type="tel"
      value={formData.passenger.phone}
      onChange={(e) => handleChange("passenger", "phone", e.target.value)}
      className="form-control"
      disabled={isCompletedInQuickbase}
    />

    <label>Date</label>
    <input
      type="date"
      value={formData.passenger.date || ""}
      onChange={(e) => handleChange("passenger", "date", e.target.value)}
      className="form-control"
      disabled={isCompletedInQuickbase}
    />

    <label>Signature</label>
    <div style={{ position: 'relative' }}>
  {signatureLoading.passenger && <Spinner />}
  <SignatureCanvas
    ref={passengerSigRef}
    penColor="black"
    onEnd={debounce(() => {
      const signature = passengerSigRef.current?.getTrimmedCanvas().toDataURL("image/png");
      setFormData(prev => ({
        ...prev,
        passenger: { ...prev.passenger, signature }
      }));
    }, 300)}
    canvasProps={{
      className: "signature-canvas",
      style: { border: "1px dashed #ccc", width: "100%", height: "150px" }
    }}
    disabled={isCompletedInQuickbase}
  />
</div>

  
    <p className="signature-hint">Sign within the box</p>
    <button type="button" onClick={() => passengerSigRef.current.clear()} className="clear-button" disabled={isCompletedInQuickbase}>
      Clear Signature
    </button>
  </div>
)}


{/* Damaged Vehicle Description */}
<div className="form-group">
  <label>Damaged Vehicle Description (Year, Make, Model)</label>
  <input
    type="text"
    value={formData.vehicle.damageDescription || ""}
    onChange={(e) =>
      setFormData((prev) => ({
        ...prev,
        vehicle: {
          ...prev.vehicle,
          damageDescription: e.target.value
        }
      }))
    }
    className="form-control"
    disabled={isCompletedInQuickbase}
  />
</div>

{/* Claimant info */}
<div className="form-group">
  <label>Claimant's Name</label>
  <input
    type="text"
    value={formData.vehicle.claimant.name}
    onChange={(e) =>
      handleNestedChange("vehicle", "claimant", "name", e.target.value)
    }
    className="form-control"
    disabled={isCompletedInQuickbase}
  />
</div>

<div className="form-group">
  <label>Claimant's Phone</label>
  <input
    type="tel"
    value={formData.vehicle.claimant.phone}
    onChange={(e) =>
      handleNestedChange("vehicle", "claimant", "phone", e.target.value)
    }
    className="form-control"
    disabled={isCompletedInQuickbase}
  />
</div>

{/* Medical Section */}
<h2 className="section-title">Medical Treatment</h2>

{/* Accompanied to Hospital/Clinic */}
<div className="form-group">
  <label>Was employee recieve medical treatment?</label>
  <div className="toggle-buttons">
    <label>
      <input
        type="checkbox"
        checked={formData.treatment.accompanied === true}
        onChange={() =>
          setFormData((prev) => ({
            ...prev,
            treatment: { ...prev.treatment, accompanied: true }
          }))
        }
        disabled={isCompletedInQuickbase}
      />
      Yes
    </label>
    <label style={{ marginLeft: "20px" }}>
      <input
        type="checkbox"
        checked={formData.treatment.accompanied === false}
        onChange={() =>
          setFormData((prev) => ({
            ...prev,
            treatment: { ...prev.treatment, accompanied: false }
          }))
        }
        disabled={isCompletedInQuickbase}
      />
      No
    </label>
  </div>
</div>

{formData.treatment.accompanied && (
  <div className="form-group">
    <label>Name of Medical Facility</label>
    <input
      type="text"
      value={formData.treatment.byWhom}
      onChange={(e) =>
        handleChange("treatment", "byWhom", e.target.value)
      }
      className="form-control"
      disabled={isCompletedInQuickbase}
    />
  </div>
)}



{/* Denied Medical Treatment */}
<div className="form-group">
  <label>Denied Medical Treatment?</label>
  <div className="toggle-buttons">
    <label>
      <input
        type="checkbox"
        checked={formData.treatment.denied === true}
        onChange={() =>
          handleChange("treatment", "denied", true)
        }
      />
      Yes
    </label>
    <label style={{ marginLeft: "20px" }}>
      <input
        type="checkbox"
        checked={formData.treatment.denied === false}
        onChange={() =>
          handleChange("treatment", "denied", false)
        }
        disabled={isCompletedInQuickbase}
      />
      No
    </label>
  </div>
</div>






{/* Was employee doing assigned job? */}
<div className="form-group">
  <label>Was employee doing assigned job?</label>
  <div className="toggle-buttons">
    <label>
      <input
        type="checkbox"
        checked={formData.injury.assignedJob === true}
        onChange={() => handleChange("injury", "assignedJob", true)}
      />
      Yes
    </label>
    <label style={{ marginLeft: "20px" }}>
      <input
        type="checkbox"
        checked={formData.injury.assignedJob === false}
        onChange={() => handleChange("injury", "assignedJob", false)}
        disabled={isCompletedInQuickbase}
      />
      No
    </label>
  </div>
</div>



{/* Did employee receive job-specific safety training? */}
<div className="form-group">
  <label>Did employee receive job-specific safety training?</label>
  <div className="toggle-buttons">
    <label>
      <input
        type="checkbox"
        checked={formData.injury.receivedTraining === true}
        onChange={() => handleChange("injury", "receivedTraining", true)}
      />
      Yes
    </label>
    <label style={{ marginLeft: "20px" }}>
      <input
        type="checkbox"
        checked={formData.injury.receivedTraining === false}
        onChange={() => handleChange("injury", "receivedTraining", false)}
        disabled={isCompletedInQuickbase}
      />
      No
    </label>
  </div>
</div>

{/* Was employee wearing proper PPE? */}
<div className="form-group">
  <label>Was employee wearing proper PPE?</label>
  <div className="toggle-buttons">
    <label>
      <input
        type="checkbox"
        checked={formData.injury.worePPE === true}
        onChange={() => handleChange("injury", "worePPE", true)}
        disabled={isCompletedInQuickbase}
      />
      Yes
    </label>
    <label style={{ marginLeft: "20px" }}>
      <input
        type="checkbox"
        checked={formData.injury.worePPE === false}
        onChange={() => handleChange("injury", "worePPE", false)}
        disabled={isCompletedInQuickbase}
      />
      No
    </label>
  </div>
</div>


{/* Supervisor's Report */}
<h2 className="section-title">Supervisor's Report</h2>

<div className="form-group">
  <label>What happened? (Supervisor's Report)</label>
  <textarea
    value={formData.supervisor.report || ""}
    onChange={(e) =>
      setFormData((prev) => ({
        ...prev,
        supervisor: {
          ...prev.supervisor,
          report: e.target.value
        }
      }))
    }
    className="form-control"
    disabled={isCompletedInQuickbase}
    placeholder="Describe what occurred during the incident..."
    rows={4}
  />
</div>

{/* Corrective Action */}
<div className="form-group">
  <label>Corrective Action Taken</label>
  <textarea
    value={formData.correctiveAction.explanation}
    onChange={(e) =>
      setFormData((prev) => ({
        ...prev,
        correctiveAction: {
          ...prev.correctiveAction,
          explanation: e.target.value
        }
      }))
    }
    className="form-control"
    disabled={isCompletedInQuickbase}
    placeholder="Describe the steps taken to correct or address the issue..."
    rows={4}
  />
</div>

<h2 className="section-title">Attach Photos</h2>
<div className="form-group">
  <label>Upload up to 10 images</label>
  <input
    type="file"
    accept="image/*"
    multiple
    onChange={handleImageUpload}
    className="form-control"
    disabled={isCompletedInQuickbase}
  />
</div>

{(imageFiles.length > 0 || formData.attachments?.imageURLs?.length > 0) && (
  <div className="image-preview-grid">
    {/* Local image files */}
    {imageFiles.map((file, index) => (
      <div key={`file-${index}`} style={{ margin: "10px", textAlign: "center" }}>
        <img
          src={URL.createObjectURL(file)}
          alt={`Preview ${index + 1}`}
          style={{ width: "150px", border: "1px solid #ccc", borderRadius: "4px" }}
        />
        <div style={{ fontSize: "0.8rem", marginTop: "4px" }}>{file.name}</div>
        <button
          type="button"
          onClick={() => handleRemoveImage(index)}
          className="clear-button"
          disabled={isCompletedInQuickbase}
          style={{ marginTop: "5px" }}
        >
          Remove
        </button>
      </div>
    ))}

    {/* Previously uploaded image URLs */}
    {formData.attachments?.imageURLs?.map((url, index) => (
      <div key={`url-${index}`} style={{ margin: "10px", textAlign: "center" }}>
        <img
          src={url}
          alt={`Uploaded ${index + 1}`}
          style={{ width: "150px", border: "1px solid #ccc", borderRadius: "4px" }}
        />
        <div style={{ fontSize: "0.8rem", marginTop: "4px" }}>Uploaded Image</div>
      </div>
    ))}
  </div>
)}




<h2 className="section-title">Signatures</h2>

{/* Supervisor */}
<div className="form-group">
  <h3>Supervisor</h3>

  <label>Name</label>
  <input
    type="text"
    value={formData.supervisor.name}
    onChange={(e) => handleChange("supervisor", "name", e.target.value)}
    className="form-control"
    disabled={isCompletedInQuickbase}
  />

  <label>Phone</label>
  <input
    type="tel"
    value={formData.supervisor.phone}
    onChange={(e) => handleChange("supervisor", "phone", e.target.value)}
    className="form-control"
    disabled={isCompletedInQuickbase}
  />

  <label>Date</label>
  <input
    type="date"
    value={formData.supervisor.date || ""}
    onChange={(e) => handleChange("supervisor", "date", e.target.value)}
    className="form-control"
    disabled={isCompletedInQuickbase}
  />

  <label>Signature</label>
  <div style={{ position: 'relative' }}>
  {signatureLoading.supervisor && <Spinner />}
  <SignatureCanvas
    ref={supervisorSigRef}
    penColor="black"
    onEnd={debounce(() => {
      const signature = supervisorSigRef.current?.getTrimmedCanvas().toDataURL("image/png");
      setFormData(prev => ({
        ...prev,
        supervisor: { ...prev.supervisor, signature }
      }));
    }, 300)}
    canvasProps={{
      className: "signature-canvas",
      style: { border: "1px dashed #ccc", width: "100%", height: "150px" }
    }}
  />
</div>


  <p className="signature-hint">Sign within the box</p>
  <button type="button" onClick={() => supervisorSigRef.current.clear()} className="clear-button" disabled={isCompletedInQuickbase}>
    Clear Signature
  </button>
</div>

{/* Driver */}
<div className="form-group">
  <h3>Driver</h3>

  <label>Name</label>
  <input
    type="text"
    value={formData.driver.name}
    onChange={(e) => handleChange("driver", "name", e.target.value)}
    className="form-control"
    disabled={isCompletedInQuickbase}
  />

  <label>Phone</label>
  <input
    type="tel"
    value={formData.driver.phone}
    onChange={(e) => handleChange("driver", "phone", e.target.value)}
    className="form-control"
    disabled={isCompletedInQuickbase}
  />

  <label>Date</label>
  <input
    type="date"
    value={formData.driver.date || ""}
    onChange={(e) => handleChange("driver", "date", e.target.value)}
    className="form-control"
    disabled={isCompletedInQuickbase}
  />

  <label>Signature</label>
  <div style={{ position: 'relative' }}>
  {signatureLoading.driver && <Spinner />}
  <SignatureCanvas
    ref={driverSigRef}
    penColor="black"
    onEnd={debounce(() => {
      const signature = driverSigRef.current?.getTrimmedCanvas().toDataURL("image/png");
      setFormData(prev => ({
        ...prev,
        driver: { ...prev.driver, signature }
      }));
    }, 300)}
    canvasProps={{
      className: "signature-canvas",
      style: { border: "1px dashed #ccc", width: "100%", height: "150px" }
    }}
  />
</div>


  <p className="signature-hint">Sign within the box</p>
  <button type="button" onClick={() => driverSigRef.current.clear()} className="clear-button" disabled={isCompletedInQuickbase}>
    Clear Signature
  </button>
</div>



<button type="button" onClick={saveDraft} className="secondary-button" disabled={isCompletedInQuickbase}>
  Save Draft
</button>




  <button type="submit" className="secondary-button" disabled={isCompletedInQuickbase}>Send Incident Report</button>
    {status && (
      <div style={{ marginTop: '1rem', fontWeight: 'bold', color: isSubmitting ? '#555' : 'green' }}>
       {status}
      </div>
    )}

<div style={{ marginTop: '0.5rem', color: '#666', fontSize: '0.85rem' }}>
  {isAutoSaving && <span>Saving draft...</span>}
  {!isAutoSaving && lastAutoSaveTime && <span>Draft auto-saved at {lastAutoSaveTime}</span>}
</div>


{lastAutoSaveTime && (
  <div style={{ marginTop: '0.5rem', color: '#666', fontSize: '0.85rem' }}>
    Draft auto-saved at {lastAutoSaveTime}
  </div>
)}

{showValidationModal && (
  <div className="custom-modal-overlay">
    <div className="custom-modal">
      <h2>Incomplete Form</h2>
      <p>Please complete all required fields, including market, signatures, and checkboxes.</p>
      <button onClick={() => setShowValidationModal(false)} className="modal-close-button" disabled={isCompletedInQuickbase}>
        Okay
      </button>
    </div>
  </div>
)}


{showSendLinkModal && (
  <div className="custom-modal-overlay">
    <div className="custom-modal">
      <h2>Send Draft for Signature</h2>

      <div className="form-group">
        <label>Recipient Email Address</label>
        <input
          type="email"
          value={recipientEmail}
          onChange={(e) => setRecipientEmail(e.target.value)}
          className="form-control"
          disabled={isCompletedInQuickbase}
          placeholder="example@email.com"
        />
      </div>

      <div className="form-group">
        <label>Required Signature Type</label>
        <div>
          <label>
            <input
              type="radio"
              value="Supervisor"
              checked={requiredSignatureType === 'Supervisor'}
              onChange={() => setRequiredSignatureType('Supervisor')}
              disabled={isCompletedInQuickbase}
            />
            Supervisor
          </label>
          <label style={{ marginLeft: '20px' }}>
            <input
              type="radio"
              value="Driver"
              checked={requiredSignatureType === 'Driver'}
              onChange={() => setRequiredSignatureType('Driver')}
            />
            Driver
          </label>
          <label style={{ marginLeft: '20px' }}>
            <input
              type="radio"
              value="Passenger"
              checked={requiredSignatureType === 'Passenger'}
              onChange={() => setRequiredSignatureType('Passenger')}
              disabled={isCompletedInQuickbase}
            />
            Passenger
          </label>
        </div>
      </div>

      
    </div>
  </div>
)}



{EmailModalOpen && selectedReport && (
  <IncidentEmailSender
    selectedReport={selectedReport}
    pdfBase64={generatedPdfBase64} 
    onClose={async () => {
      try {
        setEmailModalOpen(false);
        setStatus('Email process complete. Generating PDF and updating QuickBase...');
    
        const incidentId = selectedReport?.id || draftId;
        if (!incidentId) {
          console.error('Incident ID not available for QuickBase update.');
          return;
        }
    
        // ✅ Generate PDF Blob from component
        const pdfBlob = await pdf(<IncidentReportPDF reportData={selectedReport} />).toBlob();
    
        // ✅ Convert Blob to Base64
        const arrayBuffer = await pdfBlob.arrayBuffer();
        const pdfBase64 = btoa(
          new Uint8Array(arrayBuffer).reduce(
            (data, byte) => data + String.fromCharCode(byte),
            ''
          )
        );
    
        // ✅ Pass to QuickBase function
        await UpdateQuickBaseIncidentReport(incidentId, generatedPdfBase64);
    
        setStatus('Incident report completed and sent to QuickBase ✅');
      } catch (error) {
        console.error('Error updating QuickBase:', error);
        setStatus('Incident report email sent, but QuickBase update failed.');
      } finally {
        setSelectedReport(null);
      }
    }}
  />
)}
{showDraftSentModal && (
  <div className="custom-modal-overlay">
    <div className="custom-modal">
      <h2>Draft Link Sent</h2>
      <p>The draft link was sent successfully! You can resume the form using the link sent to the recipient's email.</p>
      <button
        onClick={() => setShowDraftSentModal(false)}
        className="modal-close-button"
        disabled={isCompletedInQuickbase}
      >
        Okay
      </button>
    </div>
  </div>
)}

{isCompletedInQuickbase && (
  <div className="readonly-alert">
    This incident report has been finalized in Quickbase and can no longer be edited.
  </div>
)}



    </form>

    
  );
}

export default IncidentReportForm;
